import { Card, styled, Button } from "@mui/material";

export const ContentBlock = styled(Card)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    backgroundColor: 'white',
    margin: "10px 0px !important",
    flexDirection: "column",
    borderRadius: theme.spacing(1.5),
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
}));

export const DataGridStyle = {
    border: 'none',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    '--DataGrid-containerBackground': '#1a1a1a',
    '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#1a1a1a !important',
        color: '#ffffff',
        fontSize: '0.875rem',
        fontWeight: 600,
    },
    '& .MuiDataGrid-columnHeaders *': {
        color: '#ffffff',
    },
    '& .MuiDataGrid-columnSeparator': {
        display: 'none',
    },
    '& .MuiDataGrid-row': {
        '&:nth-of-type(odd)': {
            backgroundColor: '#ffffff',
        },
        '&:nth-of-type(even)': {
            backgroundColor: '#f8f9fa',
        },
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04) !important',
        },
    },
    '& .MuiDataGrid-cell': {
        borderBottom: '1px solid #f1f5f9',
        fontSize: '0.875rem',
    },
    '& .MuiDataGrid-footerContainer': {
        borderTop: '1px solid #f1f5f9',
        backgroundColor: '#fafafa',
    },
    '& .font-color-completion': {
        backgroundColor: 'rgba(16, 185, 129, 0.08)',
        '&:hover': {
            backgroundColor: 'rgba(16, 185, 129, 0.12)',
        },
    },
}

export const CustomStartButton = styled(Button)(({ theme }) => ({
    background: "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)",
    color: 'white',
    borderRadius: 8,
    padding: theme.spacing(0.75, 1.5),
    textTransform: 'none',
    fontWeight: 500,
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.2s ease',
    '&:hover': {
        background: "linear-gradient(135deg, #2d2d2d 0%, #404040 100%)",
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
        transform: 'translateY(-1px)',
    },
}));